export default function stopEventPropagation(e) {
  e.stopPropagation()
}
